import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholiwaterpark() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Water Park',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Water Park',
        headingDescription: 'Splash into fun at Anand Krushi Paryatan Kendra, the premier Morachi Chincholi Water Park experience just 55 km from Pune. Set within a sprawling 40-acre agri-tourism farm, this eco-friendly destination transforms summer days into wet-and-wild adventures. Dive into a refreshing day filled with swimming in the private pool, exhilarating rain dance sessions, and boating in serene waters—perfect for families, friends, and school outings. Complemented by traditional village games, puppet shows, and magic performances, the day offers both high-energy excitement and cultural charm.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Family-Friendly Splash Pool",
    "description": "Enjoy a cool dip in a clean and safe splash pool designed for both kids and adults, surrounded by lush farm views—perfect for beating the summer heat."
  },
  {
    "title": "Colorful Water Slides",
    "description": "Slide into fun on exciting mini water slides—great for children and a favorite among weekend family visitors to Morachi Chincholi."
  },
  {
    "title": "Rain Dance with DJ",
    "description": "Dance to Bollywood and Marathi beats under a refreshing rain shower setup—an energetic way to let loose with friends and family."
  },
  {
    "title": "Kids Water Play Zone",
    "description": "Let the little ones splash around in specially designed shallow areas with animal-themed fountains and fun water toys."
  },
  {
    "title": "Poolside Rest & Refreshment Zone",
    "description": "Relax beside the pool with shaded seating, traditional snacks, and cool sugarcane juice available at nearby farm stalls."
  }
],




"services": [
  {
    "name": "Family Water Park Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra offers a relaxing and fun-filled water park experience for families. Enjoy refreshing water activities set against the backdrop of nature and rural surroundings, ideal for weekend getaways."
  },
  {
    "name": "Kids-Friendly Water Rides",
    "description": "Let the kids splash and play in our specially designed water rides that are both fun and safe. Shallow pools, mini slides, and colorful play structures make it a hit with children of all ages."
  },
  {
    "name": "Water Slides and Pools",
    "description": "Our water park features thrilling slides and clean pools for all age groups. Whether you're looking for a dip or an adrenaline splash, there's something for everyone at Anand Krushi Paryatan Kendra."
  },
  {
    "name": "Rain Dance Near Morachi Chincholi",
    "description": "Enjoy the beat of energetic music under our rain dance setup! A popular attraction for both adults and kids, this water experience adds a festive touch to your day trip."
  },
  {
    "name": "Water Play Zones for Kids",
    "description": "Dedicated water play zones ensure children can enjoy the day safely. Water sprays, buckets, mini fountains, and games keep them entertained in a controlled environment."
  },
  {
    "name": "Picnic Plus Water Park Combo",
    "description": "Make the most of your day with our picnic and water park package. Enjoy traditional farm meals, open-air relaxation, and plenty of time in the water—all in one location."
  },
  {
    "name": "Affordable Water Parks Near Pune",
    "description": "Anand Krushi Paryatan Kendra is an affordable destination just a short drive from Pune, offering water fun, nature activities, and wholesome food at pocket-friendly prices for all age groups."
  },
  {
    "name": "One-Day Fun Water Park Outing",
    "description": "Escape the routine and treat your family to a one-day water adventure. With water slides, pools, outdoor games, and fresh meals, it’s a full package of rural refreshment and entertainment."
  },
  {
    "name": "Morachi Chincholi Water-Based Activities",
    "description": "In addition to traditional farm experiences, enjoy water-based fun like splash pools, rain dance, and water games. A unique blend of agro-tourism and aqua fun near Pune."
  },
  {
    "name": "Weekend Water Park Trip from Pune",
    "description": "Plan a refreshing weekend trip from Pune with a visit to our water park and farm. Just 1.5 hours away, it’s perfect for families looking for a relaxing yet activity-packed escape."
  },
  {
    "name": "Clean and Safe Water Park Options",
    "description": "We prioritize hygiene and safety. Our water park is regularly maintained, with filtered water and supervised zones to ensure a secure and enjoyable time for all visitors."
  },
  {
    "name": "Group Bookings for Water Fun",
    "description": "Planning a school trip or corporate outing? We offer customized group packages with water access, meals, games, and relaxation spaces at discounted group rates."
  },
  {
    "name": "Water Adventure Zones",
    "description": "Add a thrill to your rural visit with our water adventure zones featuring multi-level slides, splash features, and obstacle sprays—fun for teens and adults alike."
  },
  {
    "name": "Water Splash Zones for Families",
    "description": "Families can unwind in our splash zones equipped with water jets, interactive sprays, and safe walk-through fountains. It’s a cool way to beat the heat together!"
  },
  {
    "name": "Nature Plus Water Park Combo",
    "description": "Experience the best of both worlds—lush farms and wet fun. After a nature walk or mango tasting session, take a refreshing dive into our water play areas for a wholesome rural retreat."
  }
],
"tableData": [
  ["Family Water Park Near Morachi Chincholi", "- Kids-Friendly Water Rides"],
  ["Water Slides and Pools", "- Rain Dance Near Morachi Chincholi"],
  ["Water Play Zones for Kids", "- Picnic Plus Water Park Combo"],
  ["Affordable Water Parks Near Pune", "- One-Day Fun Water Park Outing"],
  ["Morachi Chincholi Water-Based Activities", "- Weekend Water Park Trip from Pune"],
  ["Clean and Safe Water Park Options", "- Group Bookings for Water Fun"],
  ["Water Adventure Zones", "- Water Splash Zones for Families"],
  ["Nature Plus Water Park Combo", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Refreshing Water Park Experience",
    "WhyChoosedescription": "Morachi Chincholi Water Park offers a perfect retreat from the summer heat with a variety of water rides and splash zones, making it an ideal spot for families and groups looking to relax and have fun."
  },
  {
    "WhyChooseheading": "Family-Friendly Environment",
    "WhyChoosedescription": "The water park is designed to cater to all age groups, featuring safe play areas for kids, thrilling slides for teens, and relaxing pools for adults, ensuring an enjoyable day out for everyone."
  },
  {
    "WhyChooseheading": "Scenic Rural Setting",
    "WhyChoosedescription": "Set amidst the picturesque surroundings of Morachi Chincholi, the water park combines natural beauty with modern amenities, offering visitors a unique blend of fun and tranquility."
  },
  {
    "WhyChooseheading": "Complementary Agro-Tourism Activities",
    "WhyChoosedescription": "Visitors can also explore nearby agro-tourism centers, enjoying activities like farm visits, bullock cart rides, and peacock watching, creating a wholesome rural experience alongside water-based fun."
  },
  {
    "WhyChooseheading": "Convenient Location Near Pune",
    "WhyChoosedescription": "Located just about 50 km from Pune, the water park is easily accessible for a day trip, providing a refreshing and exciting escape from city life without long travel times."
  },
  {
    "WhyChooseheading": "Affordable Entry and Packages",
    "WhyChoosedescription": "The water park offers reasonable entry fees and combo packages with other local attractions, making it a cost-effective and fun destination for families, friends, and tourists."
  }
]



















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What is the Water Park at Morachi Chincholi?',
    answer: 'The Water Park at Morachi Chincholi is a recreational facility offering various water-based activities such as swimming pools, rain dance, and water slides, set amidst the natural beauty of the region.',
  },
  {
    id: 'FAQ2',
    question: 'Where is the Water Park located?',
    answer: 'The Water Park is located at Anand Krushi Paryatan Kendra, Morachi Chincholi, approximately 55 km from Pune.',
  },
  {
    id: 'FAQ3',
    question: 'What activities are available at the Water Park?',
    answer: 'Activities include swimming pools, rain dance, water slides, and other water-based games, providing fun for all age groups.',
  },
  {
    id: 'FAQ4',
    question: 'Are there any age restrictions for the Water Park?',
    answer: 'The Water Park is designed for all age groups. However, children below a certain age may require adult supervision. Specific age-related guidelines can be obtained from the park authorities.',
  },
  {
    id: 'FAQ5',
    question: 'What are the operating hours of the Water Park?',
    answer: 'The Water Park operates from 9:30 AM to 6:00 PM. It is advisable to check with the park for any changes in timings.',
  },
  {
    id: 'FAQ6',
    question: 'Is there an entry fee for the Water Park?',
    answer: 'Yes, the entry fee is ₹750 per adult and ₹500 per child. Group discounts are available for larger groups.',
  },
  {
    id: 'FAQ7',
    question: 'Is food available at the Water Park?',
    answer: 'Yes, the park offers a variety of food options, including traditional Maharashtrian cuisine, snacks, and beverages.',
  },
  {
    id: 'FAQ8',
    question: 'Is the Water Park suitable for families?',
    answer: 'Absolutely! The Water Park is family-friendly, offering activities and amenities suitable for all members of the family.',
  },
  {
    id: 'FAQ9',
    question: 'How can I book tickets for the Water Park?',
    answer: 'Tickets can be booked online through the official website or by contacting the park directly at +91 9689125047.',
  },
  {
    id: 'FAQ10',
    question: 'Are there any special events or packages?',
    answer: 'Yes, the park offers special packages for school picnics, group outings, and seasonal events. It is recommended to inquire about these packages in advance.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil, Pune',
    feedback: "Our family had a fantastic time at the Water Park in Morachi Chincholi. The facilities were excellent, and the natural surroundings made the experience even more enjoyable.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Deshmukh, Pune',
    feedback: "The Water Park is a hidden gem! It's a perfect getaway from the city hustle, offering fun activities and a peaceful environment.",
    rating: 5,
  },
];






















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mango Mahotsav Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/mango-mahotsav-morachi-chincholi.jpg",
  "description": "Celebrate the seasonal Mango Mahotsav at Morachi Chincholi with organic mango tasting, farm tours, cultural shows, aamras parties, mango cooking classes, and fun mango-themed activities perfect for families and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1725"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "850",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/mango-mahotsav"
  }
};




    return (
        <div>
<Helmet>
  <title>Mango Mahotsav Morachi Chincholi | Seasonal Mango Festival & Farm Experiences</title>
  <meta 
    name="description" 
    content="Join the Mango Mahotsav at Morachi Chincholi featuring organic mango tasting, farm tours, cultural shows, aamras parties, cooking classes, and fun mango-themed games and contests for all ages." 
  />
  <meta 
    name="keywords" 
    content="Seasonal mango festival in Morachi Chincholi, Organic mango tasting events, Mango-themed farm experiences, Mango farm tours near Pune, Family mango events in Morachi Chincholi, Cultural shows during mango festival, Aamras parties in summer, Mango cooking classes and food stalls, Mango-based games and contests, Local mango produce stalls, Kids mango festival events, Mango tree plantation experience, Summer celebration near Pune, Agro-tourism mango festival, Group events during Mango Mahotsav" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholiwaterpark;